export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";